<template>
  <a-modal
    title="新建发票"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" :layout="formLayout">
        <a-row>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同类别" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-cascader
                v-decorator="[
                  'contract_type',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                :options="this.tradePaymentRelatedContract"
                placeholder="请选择"
                @change="contractTypeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="contractType === 100">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="contractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="contractType === 200">
            <a-form-item label="普通合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="contractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in contractList">{{ val.contract_name }}（{{ val.business_no }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="客户" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'client_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入客户"
                :default-active-first-option="false"
                @search="this.clientSearch"
                @change="handleClientChange"
              >
                <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                  {{ d.client }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'invoice_contract_type',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in invoiceContractTypeList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              发票信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开票主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="invoiceIssuerCorporationFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'invoice_issuer_corporation_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入公司名称"
                :default-active-first-option="false"
                @search="this.invoiceIssuerCorporationSearch"
              >
                <a-spin v-if="invoiceIssuerCorporationFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in invoiceIssuerCompanyList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'invoice_type',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in invoiceTypeList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['invoice_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" v-decorator="['invoice_quantity', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="数量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['invoice_amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              收票信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="收票主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="recipientCorporationFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'recipient_corporation_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入公司名称"
                :default-active-first-option="false"
                @search="this.recipientCorporationSearch"
              >
                <a-spin v-if="recipientCorporationFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in recipientCompanyList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="纳税人识别号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['taxpayer_identification_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开户行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="账号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_account', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="地址" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['address', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="电话" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['phone', {rules: [{required: false, message: '必填项，请填写信息'}, {max:20, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="税额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['total_tax', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="税额"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="发票方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-textarea :rows="1" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启审批" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-divider orientation="left">
              明细信息
            </a-divider>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-form-item label="明细" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddDetail">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.detail"
                :columns="detailColumns"
                v-if="this.otherData.detail.length > 0"
                :pagination="false"
                key="key">
                <div slot="money_render" slot-scope="text" style="text-align: right;">
                  {{ (text / 1).toFixed(2) | numberFormat }}
                </div>
                <div slot="rate_render" slot-scope="text" style="text-align: right;">
                  {{ text }}%
                </div>
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.detail.length"
                    title="确定删除?"
                    @confirm="() => onDetailDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <component
        :ref="currentComponent"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :is="currentComponent"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl"></component>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { project_list } from '@/api/trade_project'
import debounce from 'lodash/debounce'
import DetailCreateForm from '../detail/modules/CreateForm'
// import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { project_client_list } from '@/api/trade_project_client'
import {
  booking_contract_list,
  charter_party_contract_list,
  freight_forwarding_contract_list,
  inspection_contract_list,
  insurance_contract_list,
  loading_supervision_contract_list,
  storage_contract_list, supervision_contract_list
} from '@/api/trade_contract'
import { sell_contract_list } from '@/api/trade_sell_contract'
import { guarantee_contract_list } from '@/api/trade_guarantee_contract'
import { contract_list } from '@/api/contract'
import { corporation_list } from '@/api/trade_corporation'
import { client_list } from '@/api/trade_client'

// 表单字段
const fields = ['business_no']
export default {
  components: {
    // AttachmentCreateForm,
    DetailCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch, 800)
    this.invoiceIssuerCorporationSearch = debounce(this.handleInvoiceIssuerCorporationSearch, 800)
    this.recipientCorporationSearch = debounce(this.handleRecipientCorporationSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      projectList: [],
      clientList: [],
      method: this.$Dictionaries.trade_fapiao_method,
      contractList: [],
      sellContractList: [],
      invoiceIssuerCompanyList: [],
      recipientCompanyList: [],
      contractType: 0,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      invoiceContractTypeList: this.$Dictionaries.trade_invoice_contract_type,
      invoiceTypeList: this.$Dictionaries.trade_invoice_type,
      currentComponent: '',
      visibleFrom: false,
      invoiceIssuerCorporationFetching: false,
      recipientCorporationFetching: false,
      confirmLoadingFrom: false,
      projectFetching: false,
      contractFetching: false,
      selectedProjectId: undefined,
      mdl: {},
      otherData: {
        attachment: [],
        detail: [],
        ordinary_contract_type: undefined
      },
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      detailColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 100,
          ellipsis: true
        },
        {
          title: '数量',
          dataIndex: 'count',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '单价',
          dataIndex: 'unit_price',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 100,
          ellipsis: true,
          align: 'center',
          customRender: (text) => this.$Dictionaries.unit[text] || '无'
        },
        {
          title: '货币',
          dataIndex: 'currency',
          width: 100,
          align: 'center',
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.currency[text] || '无'
        },
        {
          title: '税率(%)',
          dataIndex: 'rate',
          width: 100,
          scopedSlots: { customRender: 'rate_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '税额',
          dataIndex: 'total_tax',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '含税金额',
          dataIndex: 'total_price',
          width: 100,
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 16 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  methods: {
    moment,
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    contractTypeChange (values) {
      if (values !== undefined && values.length === 2) {
        this.contractType = values[0]
        this.contractList = []
        this.sellContractList = []
        this.form.setFieldsValue({ sell_contract_id: undefined })
        this.form.setFieldsValue({ contract_id: undefined })
        if (values[0] === 100) {
          this.handleSellContractSearch(values[1])
        } else {
          this.handleContractSearch(values[1])
        }
      }
    },
    contractApiByType (type) {
      switch (type) {
        case 201:
          return storage_contract_list
        case 206:
          return freight_forwarding_contract_list
        case 203:
          return charter_party_contract_list
        case 204:
          return booking_contract_list
        case 205:
          return inspection_contract_list
        case 207:
          return loading_supervision_contract_list
        case 202:
          return insurance_contract_list
        case 208:
          return supervision_contract_list
        case 209:
          return guarantee_contract_list
        default:
          return contract_list
      }
    },
    handleContractSearch (type) {
      if (this.selectedProjectId === undefined) {
        return
      }
      this.otherData.ordinary_contract_type = type
      this.contractFetching = true
      this.contractApiByType(type)({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.contractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.business_no === current.business_no)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.contractFetching = false
      })
    },
    handleSellContractSearch (value) {
      this.contractFetching = true
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999, type: (value === 101 ? 1 : 2) }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.contractFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.sellContractList = []
        this.clientList = []
        this.form.setFieldsValue({ sell_contract_id: undefined })
        this.form.setFieldsValue({ client_id: undefined })
        // this.handleSellContractSearch()
        this.handleClientSearch(undefined)
      }
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.selectedProjectId }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleInvoiceIssuerCorporationSearch (value) {
      this.handleCorporation({ name: value }, 1)
    },
    handleRecipientCorporationSearch (value) {
      // this.handleCorporation({ name: value }, 2)
      this.clientLoadList({ name: value })
    },
    clientLoadList (parameter) {
      this.recipientCorporationFetching = true
      client_list(parameter).then((res) => {
        this.recipientCompanyList = res.data.entries || []
      }).finally(() => {
        this.recipientCorporationFetching = false
      })
    },
    handleCorporation (parameter, index) {
      if (index === 1) {
        this.invoiceIssuerCorporationFetching = true
      } else {
        this.recipientCorporationFetching = true
      }
      corporation_list(parameter).then((res) => {
        if (index === 1) {
          this.invoiceIssuerCompanyList = res.data.entries || []
        } else {
          this.recipientCompanyList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.invoiceIssuerCorporationFetching = false
        } else {
          this.recipientCorporationFetching = false
        }
      })
    },
    handleClientChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment () {
      this.currentComponent = 'AttachmentCreateForm'
      this.visibleFrom = true
    },
    handleAddDetail () {
      this.currentComponent = 'DetailCreateForm'
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    onDetailDelete (key) {
      const dataSource = [...this.otherData.detail]
      this.otherData.detail = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs[this.currentComponent].form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            const current_date = new Date()
            values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
            this.otherData.attachment.push(values)
          } else if (this.currentComponent === 'DetailCreateForm') {
            const current_date = new Date()
            values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
            this.otherData.detail.push(values)
          }
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.detail) {
        this.otherData.detail = this.otherData.detail.map(item => {
          item.key = undefined
          return item
        })
      }
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.$emit('ok', this.otherData)
    }
  }
}
</script>
